import { render, staticRenderFns } from "./InformationLayout.vue?vue&type=template&id=09d3ad7e&"
import script from "./InformationLayout.vue?vue&type=script&lang=js&"
export * from "./InformationLayout.vue?vue&type=script&lang=js&"
import style0 from "./InformationLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports